var map = {
	"./example01-01.svg": 89731,
	"./example01-02.svg": 28240,
	"./example02-01.svg": 72046,
	"./example02-02.svg": 20397,
	"./example02-03.svg": 21452,
	"./example02-04.svg": 55347,
	"./example03-01.svg": 49689,
	"./example03-02.svg": 23690,
	"./example03-03.svg": 65659,
	"./example04-01.svg": 59980,
	"./example04-02.svg": 39007,
	"./example04-03.svg": 8014,
	"./example05-01.svg": 13991,
	"./example05-02.svg": 42484,
	"./example05-03.svg": 87413,
	"./measuring.svg": 8803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32590;